/**************************************************
 * Nombre:       Visualizador_Habitacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useEffect, useState} from "react";
import Tarjeta_Torre_Vista from "./Tarjetas/Tarjeta_Torre_Vista";
import {poblarReservacionesVista} from "../Funciones/poblarReservacionesVista";
import {ordenarHabitacionesTorrePiso} from "../Funciones/ordenarHabitacionesTorrePiso";

const Visualizador_Habitaciones = ({
                                       habitaciones,
                                       reservas = [],
                                       click,
                                       fechaEscogida,
                                   }) => {
    const [arrHabitaciones, setArrHabitaciones] = useState([])


    useEffect(() => {

        let arrPobladas = poblarReservacionesVista({
            reservaciones: reservas,
            arrHabitaciones: habitaciones,
            fechaEscogida: fechaEscogida
        })

        let habOrdenadas = ordenarHabitacionesTorrePiso({arrHabitaciones: arrPobladas})
        setArrHabitaciones(habOrdenadas)


    }, [reservas])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >


            {arrHabitaciones.map((item, index) => {
                return (
                    <Grid container size={{xs: 12, sm: 12, md: 6}} justifyContent={'center'}>
                        <Tarjeta_Torre_Vista click={click} reservasDia={reservas} fechaDia={fechaEscogida} item={item}
                        />
                    </Grid>
                )
            })}

        </Grid>
    )

}
export default Visualizador_Habitaciones